module.exports = __webpack_public_path__ + "static/media/sustainability-hero@2x.fab6eb40.jpg";